import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { calculateFieldValues } from '../../../calculateFieldValues';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * InitialGlobalFieldsProcessor формирует начальные значения полей виджета.
 */
export class InitialGlobalFieldsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const fieldsList = Object.values(additionalServiceState.ServicesPath)
      .map((s) => s.fields)
      .flat(1)
      .sort((a, b) => (a.id < b.id ? 1 : -1));

    const fieldValues: { [T in string]: number } = {};
    fieldsList.map((f) => {
      fieldValues[f.code] = additionalServiceState.FieldValues[f.code] ?? f.value ?? 0;
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        FieldsToDisplay: fieldsList,
        FieldValues: calculateFieldValues(fieldsList, fieldValues, {}),
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
